import { render, staticRenderFns } from "./EmptyTrash.vue?vue&type=template&id=43316890"
import script from "./EmptyTrash.vue?vue&type=script&lang=js"
export * from "./EmptyTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports